import React from 'react';
import { AlertTriangle, Clock } from 'lucide-react';
import { Button } from '../ui/Button';
export function RateLimitWarning() {
  return <div className="bg-warning-500/10 border border-warning-500/20 rounded-lg p-4 flex items-start gap-3">
      <AlertTriangle className="w-5 h-5 text-warning-500 flex-shrink-0 mt-0.5" />
      <div className="flex-1">
        <h4 className="text-sm font-medium text-warning-500">
          Approaching rate limit
        </h4>
        <p className="text-sm text-warning-200/70 mt-1">
          15 requests remaining this hour.
        </p>
      </div>
      <Button variant="ghost" size="sm" className="text-warning-500 hover:text-warning-400 hover:bg-warning-500/10">
        Upgrade Plan
      </Button>
    </div>;
}
export function RateLimitPaused() {
  return <div className="bg-surface-800 border border-surface-500 rounded-xl p-6 text-center max-w-sm">
      <div className="w-12 h-12 rounded-full bg-warning-500/10 flex items-center justify-center mx-auto mb-4">
        <Clock className="w-6 h-6 text-warning-500" />
      </div>
      <h3 className="text-lg font-semibold text-text-primary mb-2">
        Paused: Rate limit reached
      </h3>
      <div className="text-3xl font-mono text-text-primary mb-4">12:34</div>
      <p className="text-sm text-text-secondary mb-6">
        Resuming automatically when limit resets.
      </p>
      <Button className="w-full bg-primary-600 hover:bg-blue-700 text-text-primary border-none">
        Switch Model
      </Button>
    </div>;
}